import { api } from 'api'
import { path } from 'ramda'
import { User } from 'typings/common_defs'

export interface RosterDetail {
  id: number
  name: string
  createdAt: string
  workers: Array<
    Pick<
      User,
      | 'id'
      | 'name'
      | 'numShiftsForCompany'
      | 'profilePicUrl'
      | 'rating'
      | 'statusForCompany'
      | 'workForCompany'
    >
  >
}

export async function getRosterDetails(rosterId: number) {
  const data = await api.post(
    '/company/graphql_dispatch/roster_detail_query_ab755033',
    {
      rosterId,
    }
  )

  return path(['data', 'data', 'company', 'rosters', 0], data) as RosterDetail
}

export function removeWorkerFromRoster(
  companyId: number,
  rosterId: number,
  workerId: number
) {
  return api.delete(
    `/company/${companyId}/roster/${rosterId}/worker/${workerId}`
  )
}
